import { t } from '@lingui/macro';
import React from 'react';
import { useSelector } from 'react-redux';
import Styled from "./VersionUpdateBanner.style";

// version naming
// v[major].[minor].[patch]
const UpdateType = {
    UPDATES: 'updates', // major or minor version update
    HOTFIXES: 'hotfixes', // patch update
};

const appVersion = process.env.REACT_APP_VERSION;
// const appVersion = 'v2.19.6';

export default function () {
    const updatedAppVersion = useSelector(state => state.App.version);

    // assumption: version string are both v[number].[number].[number]
    const currentVersionSplit = appVersion.split('.');
    const updatedVersionSplit = updatedAppVersion.split('.');

    const getUpdateType = () => {
        // console.log('aaa TopbarUpdateAvailable', {
        //     appVersion, updatedAppVersion
        // });
        // major or minor version update
        if ((currentVersionSplit[0] !== updatedVersionSplit[0]) ||
            (currentVersionSplit[1] !== updatedVersionSplit[1]))
            return UpdateType.UPDATES;
        // patch updates
        if (currentVersionSplit[2] !== updatedVersionSplit[2])
            return UpdateType.HOTFIXES;
        // unchanged
        return null;
    };

    const getUpdateText = updateType => {
        switch (updateType) {
            case UpdateType.UPDATES:
                return t`Update available, save your work immediately and click here to update Bukku.`;
            case UpdateType.HOTFIXES:
                return t`Hotfix available, save your work and click here to update Bukku.`;
            default:
                return null;
        }
    };

    const getClassName = updateType => `updates-available ${updateType}`;

    const reloadPage = () => {
        window.location.reload();
    };

    const updateType = getUpdateType();
    const updateText = getUpdateText(updateType);
    const className = getClassName(updateType);

    if (updateType && window.location.pathname !== '/shoebox') {
        return (
            <Styled className={className} onClick={reloadPage}>
                {updateText}
            </Styled>
        );
    }
    return null;
}
